<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger fade show" role="alert" v-if="orderValidationRulesResults !== null && orderValidationRulesResults.length > 0">
                    <div v-for="orderValidationRulesResult in orderValidationRulesResults">
                        <p v-if="!orderValidationRulesResult.isValid">
                            {{orderValidationRulesResult.message}}
                        </p>
                    </div>
                </div>
                <div v-if="!showSuccessMessage && !showErrorMessage">
                    <div>
                        <div class="row">
                            <div class="col-md-6">
                                <h5>Customer Details</h5>
                                <p>
                                    Customer: {{selectedCompany.registeredCompanyName}}
                                </p>
                                <p v-if="selectedCompany.tradingAs">
                                    Trading As: {{selectedCompany.tradingAs}}
                                </p>
                                <p v-if="selectedCompany.branchName">
                                    Branch: {{selectedCompany.branchName}}
                                </p>
                                <p v-if="selectedCompany.branchNumber">
                                    Branch Number: {{selectedCompany.branchNumber}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Customer Purchase Order Number</label>
                        <div class="text-danger" v-if="order.customerPurchaseOrderNumber.hasError">
                            {{order.customerPurchaseOrderNumber.errorMessage}}
                        </div>
                        <input class="form-control" type="text" v-model="order.customerPurchaseOrderNumber.value"/>
                    </div>
                    <div class="form-group">
                        <label>Expected Date of Upliftment</label>
                        <div class="text-danger" v-if="order.expectedUpliftmentDate.hasError">
                            {{order.expectedUpliftmentDate.errorMessage}}
                        </div>
                        <date-picker :format="'DD/MM/YYYY'" :elementId="'expectedDateOfDeliverySelect'" :date="order.expectedUpliftmentDate.value"
                                     :startDate="expectedDateOfUpliftmentStartDate"
                                     :initialiseDate="initialiseExpectedDate"
                                     @dateChange="onExpectedDateOfUpliftmentSelect"></date-picker>
                    </div>
                    <div class="form-group">
                        <label>Terminal</label>
                        <bootstrap-select  :selectOptions="terminals" :selectedOption="order.terminalId.value" :elementId="'terminalSelect'"
                                           :returnSelectedOptionText="true"
                                           @changeSelect="onTerminalSelect"></bootstrap-select>
                    </div>
                    <div class="pt-3">
                        <label>Select Product</label>
                        <div class="text-danger" v-if="order.productsHasError">
                            {{order.productsErrorMessage}}
                        </div>
                        <product-select-for-exTank-order
                            :zoneId="order.selectedTerminal.zoneId"
                            :companyId="company.companyId"
                            @productSelected="onProductSelected"></product-select-for-exTank-order>
                    </div>
                    
                    <div class="form-group">
                        <label>Transporter</label>
                        <div class="text-danger" v-if="order.transporter.hasError">
                            {{order.transporter.errorMessage}}
                        </div>
                        <input class="form-control" type="text" v-model="order.transporter.value"/>
                    </div>
                    <div class="form-group">
                        <label>Vehicle Make</label>
                        <div class="text-danger" v-if="order.vehicleMake.hasError">
                            {{order.vehicleMake.errorMessage}}
                        </div>
                        <input class="form-control" type="text" v-model="order.vehicleMake.value"/>
                    </div>
                    <div class="form-group">
                        <label>Vehicle Model</label>
                        <div class="text-danger" v-if="order.vehicleModel.hasError">
                            {{order.vehicleModel.errorMessage}}
                        </div>
                        <input class="form-control" type="text" v-model="order.vehicleModel.value"/>
                    </div>
                    <div class="form-group">
                        <label>Vehicle Registration</label>
                        <div class="text-danger" v-if="order.vehicleRegistration.hasError">
                            {{order.vehicleRegistration.errorMessage}}
                        </div>
                        <input class="form-control" type="text" v-model="order.vehicleRegistration.value"/>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="onModalSaveClick" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage">PLACE ORDER</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage">CLOSE</button>
                <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="clearMessageAlerts">OK</button>
            </div>
        </div>
    </div>
</div>